import React from 'react';
import { translate } from '@portal/services/i18n';
import Logo from '@portal/assets/svg/logos/login_logo.svg?react';
import useReduxState from '@portal/hooks/useReduxState';

const IncognitoBrowser = () => {
  const {
    theme: { currentTheme },
  } = useReduxState();

  return (
    <div className="login" style={{ background: currentTheme.background }}>
      <div className="login__incognito">
        <div className="login__page__logo">
          <img
            src="../../../assets/img/background.png"
            alt="logo"
            className="login__page__logo__image"
          />
        </div>
        <div className="login__page__form">
          <div
            {...{ testId: 'login_Logo' }}
            className="login__container__form__inner__logo"
          >
            <Logo
              className="login__container__form__inner__logo__svg"
              height={70}
            />
          </div>
          <span className="login__deniedText">
            {translate('PAGES.AUTH.INCOGNITO_BROWSER.DESCRIPTION')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default IncognitoBrowser;
